export default "__VITE_ASSET__9a709b84__"